import moment from 'moment';
import { API } from 'utils';
import { GW_SERVICES_PREFIXES } from 'constants/gateway';
import {
  IConversationParams,
  IMessagesParams,
} from 'store/models/messenger/types';
import { ConversationDTO, MessageDTO, SearchMessageDTO } from './dto';
import {
  CreateMessageParams,
  GetConversationsBySubstringParams,
} from './types';

const { CHAT, REQUEST } = GW_SERVICES_PREFIXES;
const PREFIX = `${REQUEST}/${CHAT}` as const;

/* Получение списка бесед */
export const GetConversations = (
  params: IConversationParams
): Promise<ConversationDTO[]> =>
  API.get(`/${PREFIX}/conversations`, undefined, params);

/** Получение списка сообщений по поиску */
export const GetConversationsBySubstring = (
  params: GetConversationsBySubstringParams
): Promise<SearchMessageDTO[]> =>
  API.get(`/${PREFIX}/message_search/substring`, undefined, params);

/* Получение беседы по ID */
export const GetConversation = (
  conversationId: string
): Promise<ConversationDTO> =>
  API.get(`/${PREFIX}/conversation/${conversationId}`);

/* Создание новой беседы */
export const CreateConversation = (params: {
  request_id: string;
}): Promise<{ id: number }> =>
  API.gatewayPost(`/${PREFIX}/conversation/`, params);

/* Получение сообщений из конкретной беседы */
export const GetMessages = (
  conversationId: string,
  params: IMessagesParams
): Promise<MessageDTO[]> =>
  API.get(
    `/${PREFIX}/conversation/${conversationId}/messages`,
    undefined,
    params
  );

/* Создание нового сообщения */
export const CreateMessage = (
  conversationId: string,
  data: CreateMessageParams
) =>
  API.gatewayPost(`/${PREFIX}/conversation/${conversationId}/message/`, data);

export const GetFilesSharedIds = (fileIds: string[]) =>
  API.gatewayPost(
    `/${PREFIX}/files/share`,
    fileIds.map((fileId) => ({
      file_id: fileId,
      filename: '',
      write_access: true,
      read_access: true,
      shared_until: moment().endOf('day'),
    }))
  );

export const UploadFiles = (formData: FormData) =>
  API.postFilesGtwy(`/${PREFIX}/files/`, undefined, formData);

/* Получение канутеров непрочитанных сообщений по id диалогов */
export const GetConversationsCounters = (conversations_ids: string[]) =>
  API.get(`/${PREFIX}/message_read/unread_amount`, undefined, {
    conversations_ids,
  });

/* Получение общего каунтера непрочитанных сообщений по всему мессенджеру */
export const GetFullCounter = () =>
  API.get(`/${PREFIX}/message_read/unread_count`);

/* Получение информации об участниках беседы (чата) */
export const GetConversationUsers = (conversationId: string) =>
  API.get(`/${PREFIX}/conversation/${conversationId}/unique_users`);

/* Получение всех файлов из беседы (чата) */
export const GetConversationFiles = (conversationId: string) =>
  API.get(
    `/${PREFIX}/conversation/${conversationId}/unique_attached_files_ids`
  );

/* Удаление сообщения */
export const DeleteMessage = (conversationId: string, messageId: string) =>
  API.delete(`/${PREFIX}/conversation/${conversationId}/message/${messageId}`);
